import { render, staticRenderFns } from "./CommentStatusIcon.vue?vue&type=template&id=62442db8"
import script from "./CommentStatusIcon.vue?vue&type=script&lang=js"
export * from "./CommentStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports